import { generateRoomsParticipantDistributionWithDefaultBirthDates } from '@/scopes/search/search/infrastructure/api/filtersSelectionMapper/mappers/roomsParticipantDistributionMapper'
import {
  type SearchFilters,
  type SearchFilterSelection,
  type SearchMultiSelectFilters,
  type SearchSelectFilters,
  SingleSelectKeys,
} from '@/scopes/search/search/infrastructure/api/types'
import { isEmpty } from 'ramda'

export function map(
  aiFilters: Record<string, string[] | null>,
  searchFilters: SearchFilters | undefined,
): SearchFilterSelection {
  if (!searchFilters)
    return {}

  const mappedFilters: SearchFilterSelection = {}
  const normalizedKeys = new Map(
    SingleSelectKeys.map(singleSelectKey => [singleSelectKey.toString(), singleSelectKey]),
  )

  for (const [key, values] of Object.entries(aiFilters) as [
    keyof Partial<SearchSelectFilters & SearchMultiSelectFilters>,
    string[] | null,
  ][]) {
    if (!Array.isArray(values) || isEmpty(values))
      continue

    if ('options' in (searchFilters[key] || {})) {
      mappedFilters[key] = processFilterWithOptions(normalizedKeys, key, values, searchFilters)
    }
    else {
      // PricePerPerson and Participants filters come through here since they are "fake" filters
      if (key.toString() === 'PricePerPerson') {
        const pricePerPersonValues = values[0] > '2000' ? ['0', null] : values
        mappedFilters[key] = [...pricePerPersonValues.map((value: string | null) => value ? Number.parseInt(value) : value)]
      }
      else if (key.toString() === 'Participants') {
        mappedFilters[key] = values.map((distribution) => {
          const [adults, children, babies] = distribution.split(':').map(Number)
          return generateRoomsParticipantDistributionWithDefaultBirthDates(adults, children, babies)
        })
      }
    }
  }

  return mappedFilters
}

function processFilterWithOptions(
  normalizedKeys: Map<string, keyof SearchSelectFilters>,
  key: keyof Partial<SearchSelectFilters & SearchMultiSelectFilters>,
  values: string[],
  searchFilters: Partial<SearchFilters>,
) {
  if (normalizedKeys.has(key)) {
    // SingleSelect
    return values[0] ?? null
  }
  else {
    // MultiSelect
    if (key === 'DepartureDate') {
      const validValues = searchFilters[key]?.options.map((option: { value: string }) => option.value)
      const validAIFilteredValues = values.filter(value => validValues?.includes(value) ?? false)
      if (validAIFilteredValues.length === values.length) {
        return values.length === 1 ? values[0] : values
      }
      return null
    }
    return values
  }
}
